module.exports = __webpack_public_path__ + "img/challenges-shape.44384cd2.png";